import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import './Services.css';

const services = [
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
        <polyline points="9 22 9 12 15 12 15 22"></polyline>
      </svg>
    ),
    title: 'Stöd till skolor',
    description:
      'Kuratorsstöd, sociala bedömningar samt individuella samtal och gruppsamtal med elever. Social kartläggning och samverkan med elevhälsoteam och skolpersonal. Vid behov stöd inom elevhälsoarbete, socialpedagogiskt arbete eller samordnande roller.',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
        <circle cx="9" cy="7" r="4"></circle>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
      </svg>
    ),
    title: 'Ungdomsarbete',
    description:
      'Arbete i team med verksamheter för barn och ungdomar — kommun, socialtjänst, fritidsgårdar och nyanlända. Som ungdomsledare eller stöd genom samtal, gruppaktiviteter och socialt stöd för att stärka delaktighet, trygghet och personlig utveckling.',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
        <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
        <line x1="12" y1="19" x2="12" y2="23"></line>
        <line x1="8" y1="23" x2="16" y2="23"></line>
      </svg>
    ),
    title: 'Föreläsningar',
    description:
      'Utgår från boken Slöjan – en kulturhistoria. Belyser hur normer, kultur och socialisation formas mellan generationer. Tvärvetenskapligt perspektiv med historia, antropologi, sociologi, genusvetenskap och neurovetenskap.',
  },
];

function Services() {
  const [headerRef, headerVisible] = useScrollReveal();
  const [gridRef, gridVisible] = useScrollReveal({ threshold: 0.1 });

  return (
    <section id="services" className="services">
      <div className="services__container">
        <div
          ref={headerRef}
          className={`services__header reveal ${headerVisible ? 'reveal--visible' : ''}`}
        >
          <h2 className="section-title">Konsulttjänster</h2>
          <p className="section-subtitle">
            Stöd till skolor, barn och ungdomar genom samtal, social kartläggning
            och föreläsningar. Arbetet utgår från elevhälsa, trygghet och social utveckling.
          </p>
        </div>
        <div
          ref={gridRef}
          className={`services__grid ${gridVisible ? 'services__grid--visible' : ''}`}
        >
          {services.map((service, index) => (
            <div
              className="service-card"
              key={index}
              style={{ transitionDelay: `${index * 0.15}s` }}
            >
              <div className="service-card__icon">{service.icon}</div>
              <h3 className="service-card__title">{service.title}</h3>
              <p className="service-card__description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
